<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-pencil
      </v-icon> Create Organization
    </h2>
    <v-card
      class="my-base-vcard-style"
    >
      <br>
      <v-card
        class="my-vcard-style"
      >
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="name"
                  label="Organization Name*"
                  hint="Name for your reference - 'DBSystems'."
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="organizationType"
                  menu-props="auto"
                  :items="organizations"
                  item-text="id"
                  item-value="value"
                  label="Organization Type*"
                  prepend-icon="mdi-domain"
                  :rules="[(v) => !!v || 'This field is required']"
                  single-line
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="organizationCategory"
                  menu-props="auto"
                  :items="organizationCategories"
                  item-text="id"
                  item-value="value"
                  label="Organization Category*"
                  prepend-icon="mdi-domain"
                  :rules="[(v) => !!v || 'This field is required']"
                  single-line
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <address-form
                  ref="addressForm"
                  @addressEntered="assiginAddress($event)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="phoneNumber"
                  label="Phone-Number"
                  type="number"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="timeZone"
                  menu-props="auto"
                  :items="timeZonesByName"
                  label="Time Zone*"
                  prepend-icon="mdi-clipboard-text-clock-outline"
                  :rules="[(v) => !!v || 'This field is required']"
                  single-line
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="alias"
                  label="Alias*"
                  hint="Name for your reference - 'DBS'"
                  :rules="[v => (v || '' ).length === 3 || 'Alias must be 3 characters']"
                  :maxlength="aliasMax"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="externalId"
                  label="Organization-Id*"
                  hint="Name for your reference - 'DBSYS'"
                  :rules="[v => (v || '' ).length === 5 || 'Organization id must be 5 characters']"
                  :maxlength="externalIdMax"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="taxId"
                  menu-props="auto"
                  :items="taxRates"
                  :item-text="showText"
                  item-value="id"
                  label="Tax Type*"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="subscriptionStatus"
                  menu-props="auto"
                  :items="subscriptionStatusTypes"
                  item-text="id"
                  item-value="value"
                  label="Subscription Status*"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
            </v-row>
          </v-form>
          <br>
          <p class="text-sm-left">
            *Indicates required field
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red darken-3"
            @click="$router.push({ name: 'Organizations' })"
          >
            Back
          </v-btn>
          <v-spacer />
          <v-btn
            color="#FF3700"
            @click="submit()"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
      <centre-spinner
        :loading="loading"
      />
      <br>
    </v-card>
  </v-container>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import AddressForm from 'src/views/dashboard/component/AddressForm';

  export default {
    name: 'CreateOrganization',
    components: {
      'centre-spinner': spinner,
      'address-form': AddressForm,
    },
    data () {
      return {
        name: '',
        organizationType: '',
        address: {},
        organizations: [{ id: 'Church', value: 'church' }, { id: 'Shopping Centre', value: 'shoppingCentre' }, { id: 'Construction', value: 'construction' }, { id: 'Restaurants', value: 'restaurants' }, { id: 'Dental', value: 'dental' }],
        phoneNumber: null,
        alias: '',
        externalId: '',
        timeZone: '',
        timeZones: ['Asia/Kolkata'],
        aliasMax: 3,
        externalIdMax: 5,
        valid: false,
        loading: false,
        organizationCategory: '',
        organizationCategories: [{ id: 'Host', value: 'host' }, { id: 'Advertiser', value: 'advertiser' }],
        taxId: '',
        subscriptionStatus: '',
        subscriptionStatusTypes: [{ id: 'Trial', value: 'trial' }, { id: 'Active', value: 'active' }, { id: 'Expired', value: 'expired' }],
      };
    },
    computed: {
      taxRates () {
        return this.$store.getters['payments/getTaxRates'];
      },
      CountryCodeList () {
        return this.$store.getters['users/getCountryCodes'];
      },
      allTimeZones () {
        return this.$store.getters['users/getTimeZones'];
      },
      timeZonesByName () {
        return Object.keys(this.allTimeZones).map((key) => ({ text: key, value: this.allTimeZones[key] }));
      },
    },
    async mounted () {
      this.loading = true;
      await this.fetchTaxRates();
      await this.getCountryCodes();
      await this.getAllTimeZone();
      this.loading = false;
    },
    methods: {
      submit () {
        this.$refs.addressForm.getEnteredAdress();
        if (this.$refs.form.validate() === false || Object.keys(this.address).length === 0) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        if (Object.keys(this.address).length > 0) {
          this.loading = true;
          this.$store.dispatch('organizations/createOrganization', {
            name: this.name,
            type: this.organizationType,
            timezone: this.timeZone,
            external_id: this.externalId.toUpperCase(),
            address: this.address,
            phone_number: this.phoneNumber,
            alias: this.alias.toUpperCase(),
            category: this.organizationCategory,
            tax_id: this.taxId,
            subscription_status: this.subscriptionStatus,
          }).then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Organization created successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.address = {};
            this.loading = false;
            this.$router.push({ name: 'Organizations' });
          }).catch(() => {
            this.loading = false;
          });
        }
      },
      assiginAddress (address) {
        this.address = address;
      },
      getAllTimeZone () {
        this.$store.dispatch('users/fetchTimeZones');
      },
      fetchTaxRates () {
        this.$store.dispatch('payments/fetchTaxRates');
      },
      getCountryCodes () {
        this.$store.dispatch('users/fetchCountryCodes');
      },
      showText (item) {
        return `${item.name} - ${this.CountryCodeList[item.country]}`;
      },
    },
  };
</script>
<style scoped>
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.title-style {
  color: #37474F;
}
.my-base-vcard-style {
  background-color: #CFD8DC !important;
}
.my-vcard-style {
  margin-right: 30px;
  margin-left: 30px;
  background-color: #ECEFF1;
  border-radius: 25px;
}
</style>
